var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","placeholder":_vm.placeholder,"clearable":true},on:{"change":_vm.onChange},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})}
var staticRenderFns = []

export { render, staticRenderFns }